import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ELocationModalActions {
  Open = 'LOCATION_MODAL/OPEN',
  Close = 'LOCATION_MODAL/CLOSE',
}

export type TOpenLocationModal = ITypedReduxAction<ELocationModalActions.Open>;
export type TCloseLocationModal = ITypedReduxAction<ELocationModalActions.Close>;

export const openLocationModal = actionGenerator<ELocationModalActions.Open>(ELocationModalActions.Open);

export const closeLocationModal = actionGenerator<ELocationModalActions.Close>(ELocationModalActions.Close);

export type TLocationModalActions = TOpenLocationModal | TCloseLocationModal;
